(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/prolong-game/assets/javascripts/common/utils.js') >= 0) return;  svs.modules.push('/components/numbergames/prolong-game/assets/javascripts/common/utils.js');

'use strict';

const productMapping = svs.numbergames.productMapping;
const {
  PROLONG_WAGERS_PARAMS
} = svs.numbergames.prolong_game.common.constants;
const checkSavedWagerInfo = wagerId => {
  const urlParams = new URLSearchParams(window.location.search);
  const {
    prepCount,
    prepDays,
    prepId
  } = PROLONG_WAGERS_PARAMS;
  if (urlParams.get(prepId) === wagerId) {
    var _urlParams$get;
    return {
      isExisting: true,
      selectedDays: (_urlParams$get = urlParams.get(prepDays)) === null || _urlParams$get === void 0 ? void 0 : _urlParams$get.split(/[-,]/),
      drawCount: urlParams.get(prepCount)
    };
  }
  return {};
};
const buildProlongHref = _ref => {
  let {
    productName,
    wagerId,
    syndicateId,
    options = {},
    isPay,
    getAfterChangeReturnUrl
  } = _ref;
  const product = productMapping.getBrandingClass(productName);
  const urlParams = Object.entries(options).map(_ref2 => {
    let [key, value] = _ref2;
    return "".concat(key, "=").concat(value);
  });
  if (syndicateId) {
    urlParams.push("syndicateId=".concat(syndicateId));
  }
  if (isPay) {
    urlParams.push('pay=true');
  }
  const returnUrl = getAfterChangeReturnUrl === null || getAfterChangeReturnUrl === void 0 ? void 0 : getAfterChangeReturnUrl();
  if (returnUrl && typeof returnUrl === 'string') {
    urlParams.push("returnUrl=".concat(encodeURIComponent(returnUrl)));
  }
  return "/".concat(product, "/forlang-mina-spel/").concat(wagerId, "?").concat(urlParams.join('&'));
};
const generateSubscriptionHref = _ref3 => {
  var _productMapping$getDa;
  let {
    productName,
    wagerId,
    selectedDays
  } = _ref3;
  const options = {
    dragningar: 'prenumerera',
    dag: selectedDays.length > 1 ? 'b' : (_productMapping$getDa = productMapping.getDay(selectedDays[0])[0]) === null || _productMapping$getDa === void 0 ? void 0 : _productMapping$getDa.toLowerCase()
  };
  return buildProlongHref({
    productName,
    wagerId,
    options,
    isPay: true
  });
};
const onboardingClosingAction = setIsOpen => {
  const closeCarousel = event => {
    event.preventDefault();
    setIsOpen(false);
  };
  const carouselItems = document.querySelectorAll('.ui-carousel-item');
  const lastAdInCarousel = carouselItems[carouselItems.length - 1];
  if (lastAdInCarousel) {
    const closeButtonArea = lastAdInCarousel.querySelectorAll('.ui-carousel-actions')[0];
    if (closeButtonArea) {
      closeButtonArea.addEventListener('click', closeCarousel);
    }
  }
  return () => {
    if (lastAdInCarousel) {
      const closeButtonArea = lastAdInCarousel.querySelectorAll('.ui-carousel-actions')[0];
      if (closeButtonArea) {
        closeButtonArea.removeEventListener('click', closeCarousel);
      }
    }
  };
};
setGlobal('svs.numbergames.prolong_game.common.utils', {
  buildProlongHref,
  checkSavedWagerInfo,
  generateSubscriptionHref,
  onboardingClosingAction
});

 })(window);